class CartDrawerSubscription extends HTMLElement {
  constructor() {
    super();
    this.changeBtn = this.querySelector(".cart-drawer-sub-btn");
    this.selectElement = this.querySelector("select");
    this.changeBtnClose = this.querySelector(".cart-drawer-sub-btn-close");
    this.loadingProgressBar = this.querySelector(".cart-drawer-progress-bar-loading");
    this.cartDrawer = null;
  }
  
  connectedCallback() {
    this.cartDrawer = document.querySelector('mini-cart')
    this.initEvent();
  }
  
  initEvent() {
    this.changeBtn.addEventListener("click", this.handleChangeBtn.bind(this));
    this.changeBtnClose.addEventListener("click", this.handleChangeBtn.bind(this));
    this.selectElement.addEventListener("change", (event) => this.handleSelectChange(event));
  }
  handleChangeBtn() {
    if(this.dataset.active === 'false') {
      this.dataset.active = 'true';
    } else {
      this.dataset.active = 'false';
    }
  }
 async handleSelectChange(event) {
    const selectedPlanId = event.target.value;
    const selectElement = event.target;
    const lineItemKey = selectElement.id; 
    
    try {
      selectElement.disabled = true;
      this.changeBtn.classList.add('hidden');
      this.handleChangeBtn();
      this.loadingProgressBar.classList.remove('hidden');
      let updates;
      if (selectedPlanId === "") {
        updates = {
          id: lineItemKey,
          selling_plan: null
        };
      } else {
        updates = {
          id: lineItemKey,
          selling_plan: parseInt(selectedPlanId)
        };
      }
        debugger;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates)
      });
      
      if (!response.ok) {
        throw new Error('Failed to update cart');
      }
    
      const cartDrawerResponse = await fetch(`/?section_id=mini-cart`);
      const cartDrawerData = await cartDrawerResponse.text();
      
       document.getElementById('mini-cart').innerHTML =
          this.cartDrawer.getSectionInnerHTML(cartDrawerData, '.shopify-section')
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      selectElement.disabled = false;
      this.loadingProgressBar.classList.add('hidden');
      this.changeBtn.classList.remove('hidden');
    }
  }
  
  disconnectedCallback() {
    this.changeBtn?.removeEventListener("click", this.handleChangeBtn.bind(this));
    this.changeBtnClose.addEventListener("click", this.handleChangeBtn.bind(this));
    this.selectElement?.removeEventListener("change", this.handleSelectChange);
  }
}

if (!customElements.get("cart-drawer-subscription")) {
  customElements.define("cart-drawer-subscription", CartDrawerSubscription);
}